import React from 'react';

const ThomasAlert: React.FC = () => (
  <section className="ErrorMessage">
    The Thomas Program Configuration Tool has encountered an error. Please contact the customer
    success team using the link below for help.<br />
    <a href="https://business.thomasnet.com/help-planets" target="blank">
      https://business.thomasnet.com/help-planets
    </a>
  </section>
);

export { ThomasAlert };
